import React from 'react';
/* eslint-disable */
export function Check(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.6875 2.71484C13.125 2.27734 13.125 1.59375 12.6875 1.15625C12.25 0.746094 11.5664 0.746094 11.1562 1.15625L4.92188 7.39062L2.1875 4.65625C1.75 4.24609 1.06641 4.24609 0.65625 4.65625C0.21875 5.09375 0.21875 5.77734 0.65625 6.21484L4.15625 9.71484C4.34766 9.93359 4.64844 10.043 4.92188 10.043C5.19531 10.043 5.46875 9.93359 5.6875 9.71484L12.6875 2.71484Z"
        fill="currentColor"
      />
    </svg>
  );
}
